/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import App from "./../helpers/app";
import Swiper from "./../libs/swiper";

const swiperElement = document.querySelector(".mySwiper");

if (swiperElement !== null) {
  let swiper = new Swiper(".mySwiper", {
    autoplay: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      bulletClass: "page",
      bulletActiveClass: "active",
    },
  });
}

window.addEventListener("load", async () => {
  const loader = document.getElementById("loader");

  if (loader === null) {
    return;
  }

  const MAX_WIDTH = 100;
  const random = getRandomInt(10, 300);

  const step = MAX_WIDTH / random;
  let currentStep = 0;

  while (currentStep < 100) {
    loader.style.width = currentStep + "%";
    if (getRandomInt(0, 100) > 90) {
      currentStep += getRandomInt(5, 10);
    }
    currentStep += step;
    if (currentStep >= 100) {
      loader.style.width = "100%";
    }
    await delay(60);
  }
});

async function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

window.addEventListener("load", async () => {
  const reservationProgressCircle = document.getElementById(
    "reservationProgressCircle",
  );

  if (reservationProgressCircle === null) {
    return;
  }

  if (
    !reservationProgressCircle.classList.contains(
      "offer-card-car-reservation-progress-animation",
    )
  ) {
    return;
  }

  let time = 30;
  const startDegrees = 45 + 1200;
  let degrees = time * 200 + startDegrees;
  reservationProgressCircle.style.transition = time + "s ";

  setTimeout(
    () => {
      reservationProgressCircle.classList.add(
        "offer-card-car-reservation-progress-100",
      );
    },
    (time - 2) * 1000,
  );

  reservationProgressCircle.style.transform = "rotate(" + degrees + "deg)";
});

window.addEventListener("load", async () => {
  const elements = document.querySelectorAll(".book-info-row");
  const elementsLen = elements.length;

  if (elementsLen === 0) {
    return;
  }

  for (let i = 0; i < elementsLen; i++) {
    let icon = elements[i].querySelector(".book-info-icon");
    let desc = elements[i].querySelector(".book-info-description");
    await delay(250);
    icon.style.opacity = 1;
    await delay(250);
    desc.style.opacity = 1;
  }
});

window.addEventListener("load", () => {
  const colorHeader = document.getElementById("colorHeader");
  const colorClickableContainer = document.getElementsByClassName(
    "form-container-body-color-container",
  )[0];
  const colorChangeButton = document.getElementById("colorChangeButton");
  const colorInput = document.getElementsByName("LeadContactForm[color]")[0];

  if (
    colorHeader === null ||
    colorClickableContainer === null ||
    colorChangeButton === null
  ) {
    return;
  }

  colorChangeButton.addEventListener("click", () => {
    colorHeader.textContent = colorHeader.dataset.originText;
    // colorClickableContainer.classList.remove('d-none');
    // colorChangeButton.classList.add('d-none');
    $(colorClickableContainer).slideDown("fast");
    $(colorChangeButton).fadeOut("fast");
    colorClickableContainer.parentNode.classList.remove("mb-0");
    colorInput.value = "";
  });

  document.querySelectorAll(".form-container-body-color-item").forEach((el) => {
    el.addEventListener("click", () => {
      let child = el.querySelector(".body-color-item-text-part");
      colorHeader.textContent = child.textContent;
      // colorClickableContainer.classList.add('d-none');
      // colorChangeButton.classList.remove('d-none');
      $(colorClickableContainer).slideUp("fast");
      $(colorChangeButton).fadeIn("fast");
      colorClickableContainer.parentNode.classList.add("mb-0");
      colorInput.value = child.textContent;
    });
  });
});

function validateMultiformPartInit(e) {
  let $input = $(this);
  let $part = $input.closest("[data-multiform-part]");
  let $form = $input.closest("form");

  $part.find(".form-group .form-control").each(function () {
    $form.yiiActiveForm("validateAttribute", $(this).attr("id"));
  });
  $part.data("validated", []);
}

function validateMultiformPart(e) {
  let $input = $(this);
  let $part = $input.closest("[data-multiform-part]");
  let $form = $input.closest("form");
  let $error = false;

  $error = $part.find(".form-group.has-error").length;
  if (!$error) {
    $part
      .find(".form-preview [data-multiform-preview-input]")
      .each(function () {
        let $value,
          $filter = null;
        let $inputPreview = $(this);
        let $input = $form.find(
          '[name="' + $inputPreview.data("multiform-preview-input") + '"]',
        );
        if ($input.length) {
          $value = $input.val();
          if (
            $inputPreview.data("multiform-preview-input-filter") &&
            typeof ($filter =
              window.multiformPreviewInputFilters[
                $inputPreview.data("multiform-preview-input-filter")
              ]) === "function"
          ) {
            $value = $filter($value, $form);
          }
          $inputPreview.html($value);
        }
      });
    $part.addClass("is-valid show-preview");
  }
}

$(function () {
  let $section = $(".section-new-lead, .section-new-lead-unstyled");
  if (!$section.length) {
    return;
  }

  let $multiform = $section.find("[data-multiform-autocheck]");
  $multiform
    .find('select, input[type="radio"], input[type="checkbox"]')
    .change(validateMultiformPartInit);
  $multiform
    .find(
      'input[type="text"], input[type="tel"], input[type="email"], input[type="number"], input[type="phone"]',
    )
    .blur(validateMultiformPartInit);

  const $form = $multiform.closest("form");

  $form.on("afterValidateAttribute", function (e, inputConfig) {
    let $input = $form.find(inputConfig.input);
    if (!$input.length) {
      return;
    }

    let $part = $input.closest("[data-multiform-part]");
    let $validated = $part.data("validated");
    if (typeof $validated !== "object") {
      return;
    }

    if ($validated.indexOf() === -1) {
      $validated.push(inputConfig.input);
    }

    if ($validated.length >= $part.find(".form-group .form-control").length) {
      validateMultiformPart.apply($input[0], e);
    }
  });

  $section.find(".form-group");
  $section
    .find('[data-multiform-part] [data-multiform-action="preview-close"]')
    .click(function () {
      $(this).closest("[data-multiform-part]").removeClass("show-preview");
    });

  let interval = setInterval(() => {
    if (typeof $form.data("yiiActiveForm") !== "undefined") {
      clearInterval(interval);

      $section
        .find("[data-multiform-autocheck][data-multiform-firstcheck]")
        .each(function () {
          $(this)
            .find(".form-group .form-control")
            .each(function () {
              if ($(this).val() !== "") {
                $(this).blur();
                return false;
              }
            });
        });
    }
  }, 50);

  $section
    .find(".check-all-rules")
    .change(function () {
      if ($(this).is(":checked")) {
        $(this)
          .closest(".form-rules-container")
          .find('.form-rules input[type="checkbox"]')
          .prop("checked", true);
      } else {
        $(this)
          .closest(".form-rules-container")
          .find('.form-rules input[type="checkbox"]')
          .prop("checked", false);
      }
    })
    .change();

  $section.find('[name*="[first_name]"]').keydown(function (e) {
    let keyCode = e.which || e.charCode;
    let key = String.fromCharCode(keyCode);
    if (
      keyCode === 8 || // backspace
      keyCode === 13 || // enter
      keyCode === 9 || // tab
      keyCode === 32 || // space
      (keyCode >= 16 && keyCode <= 18) || // shift, ctrl, alt
      (keyCode >= 37 && keyCode <= 40) // arrows
    ) {
      return true;
    }

    if (/[a-zA-Z]/i.test(key) === false) {
      e.preventDefault();
    }
  });

  $section
    .find('[name*="[contract_type]"]')
    .change(function () {
      $section.find(".contract_type-form-parent").hide();
      if ($.inArray($(this).val(), ["uop"]) !== -1) {
        $section.find(".unlimited_contract-form-child").show();
      }
    })
    .change();

  $section
    .find('[name*="[marital_status]"]')
    .change(function () {
      $section.find(".marital_status-form-parent").hide();
      if ($.inArray($(this).val(), ["single", "divorced", "widowed"]) !== -1) {
        $section.find(".working_abroad-form-child").show();
      }
      if ($.inArray($(this).val(), ["married"]) !== -1) {
        $section.find(".property_community-form-child").show();
      }
    })
    .change();

  let offerTypeChange = function () {
    $section.find(".offer_type-form-parent").hide();
    $section.find('[name*="[nip_nr]"]').removeAttr("disabled").val("");
    $section
      .find('.form-rules-container input[type="checkbox"]')
      .prop("checked", false);
    $section.find("[data-rule-clientTypes]").hide();
    if (
      $(this).val() === "personal" &&
      ($(this).is('[type="hidden"]') || $(this).prop("checked"))
    ) {
      $section.find(".personal_data-form-child").show();
      $section.find('[name*="[nip_nr]"]').attr("disabled", "disabled");
      $section.find('[data-rule-clientTypes*="of"]').show();
    } else {
      $section.find(".company_data-form-child").show();
      $section.find('[data-rule-clientTypes*="jdg"]').show();
    }
  };
  $section.find('[name*="[offer_type]"]').change(offerTypeChange);
  offerTypeChange.apply(
    $section.find('[name*="[offer_type]"][type="checkbox"]').length
      ? $section.find('[name*="[offer_type]"][type="checkbox"]')[0]
      : $section.find('[name*="[offer_type]"][type="hidden"]')[0],
  );

  $section.find("form").submit(function (e) {
    let $form = $(this);
    let $validation = $form.data("yiiActiveForm");
    let $formButton = $form.find('button[type="submit"]');
    if (typeof $validation !== "undefined" && $validation.validated) {
      App.loader.init($formButton, "button");
    } else {
      let anchor = $(".error-scroll-anchor");
      if (anchor.length) {
        $("html, body").animate(
          {
            scrollTop:
              window.scrollY +
              anchor.first().get(0).getBoundingClientRect().top -
              $("header").outerHeight(),
          },
          "50",
        );
      }
    }
  });
});
